// DO NOT CHANGE THIS FILE MANUALLY.
// It was generated using scripts/lib/template.ts
import * as React from "react";
export const IconDivide = ({
  size,
  onClick,
  ...otherProps
}: React.SVGProps<SVGSVGElement> & {
  /** @deprecated - wrap in a `<DDSButton variant="ghost">` put the onClick on there */ onClick?: never;
  size?: "xs" | "s" | "m" | "l" | "xl" | "xxl";
}) => {
  const props = {
    ...otherProps,
    className: "mdsIcon " + (size || "") + " " + (otherProps.className || ""),
  };
  return (
    <svg {...props} viewBox="0 0 64 64" xmlns="http://www.w3.org/2000/svg">
      <path d="M27 17C27 13.9148 28.9148 12 32 12C35.0852 12 37 13.9148 37 17C37 20.0852 35.0852 22 32 22C28.9148 22 27 20.0852 27 17ZM32 42C28.9148 42 27 43.9148 27 47C27 50.0852 28.9148 52 32 52C35.0852 52 37 50.0852 37 47C37 43.9148 35.0852 42 32 42ZM50 28.125C48.8646 28.125 41.6583 29.125 32 29.125C22.3417 29.125 15.1354 28.125 14 28.125C12.7659 28.125 12 28.8909 12 30.125V33.875C12 35.1091 12.7659 35.875 14 35.875C15.1354 35.875 22.3417 34.875 32 34.875C41.6583 34.875 48.8646 35.875 50 35.875C51.2341 35.875 52 35.1091 52 33.875V30.125C52 28.8909 51.2341 28.125 50 28.125Z" />
    </svg>
  );
};
